import React from "react";

import Modal from "./Modal";
import CustomSpinner from "components/Loader/CustomSpinner";

const LeadgerLoadingModal = ({ isVisible }) => (
  <>
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="connect-modal connect-option card px-3 py-4"
    >
      <div className="heading">
        <h4 className="mb-4">Connecting Ledger...</h4>
      </div>
      <div className="body loading">
        <CustomSpinner />
      </div>
      <div className="footer">
        <p className="py-2">Please wait for few seconds.</p>
      </div>
    </Modal>
  </>
);

export default LeadgerLoadingModal;
